export const CHANNEL_RESET_STATE = 'CHANNEL_RESET_STATE';
export const CHANNEL_CURRENT_ITEM = 'CHANNEL_CURRENT_ITEM';
 
export const CHANNEL_REQUEST_LOADING = 'CHANNEL_REQUEST_LOADING';
export const CHANNEL_REQUEST_SUCCESS = 'CHANNEL_REQUEST_SUCCESS';
export const CHANNEL_REQUEST_FAILED = 'CHANNEL_REQUEST_FAILED';
 
export const CHANNEL_CURRENT_ACTION = 'CHANNEL_CURRENT_ACTION';
export const CHANNEL_RESET_ACTION = 'CHANNEL_RESET_ACTION';